module.exports = __webpack_public_path__ + "img/irrigation-control-1.69ff69e1.jpg";